import { AnimatePresence, useReducedMotion } from 'motion/react';
import React from 'react';

import {
  OptionItemSquareWithIconListStyles,
  OptionItemSquareWithIconStyles,
  OptionItemSquareWithIconTitleStyles,
} from './OptionItemSquareWithIcon.styles';

export const OptionItemSquareWithIconList: React.FC<{
  children?: NonNullable<React.ReactNode>;
  className?: string;
}> = ({ children, className }) => {
  return (
    <OptionItemSquareWithIconListStyles className={className}>
      {children}
    </OptionItemSquareWithIconListStyles>
  );
};

export const OptionItemSquareWithIcon: React.FC<{
  title: string;
  isSelected: boolean;
  onClick: () => void;
  TEST_ID?: string;
  Icon?: React.ElementType;
  animate?: boolean;
  show: boolean;
}> = ({ title, isSelected, onClick, TEST_ID, Icon, animate, show }) => {
  const shouldReduceMotion = useReducedMotion();
  const canAnimate = animate && !shouldReduceMotion;

  if (canAnimate) {
    const scale = isSelected ? 1.03 : 0.97;

    return (
      <AnimatePresence>
        {show && (
          <OptionItemSquareWithIconStyles
            isSelected={isSelected}
            onClick={onClick}
            data-testid={TEST_ID}
            initial={{
              opacity: 0.5,
              scale: 0.8,
            }}
            animate={{
              opacity: 1,
              scale: scale,
            }}
            exit={{
              opacity: 0.5,
              scale: 0.8,
            }}
            transition={{
              duration: 0.3,
              bounce: 0.5,
            }}
          >
            {Icon && <Icon />}
            <OptionItemSquareWithIconTitleStyles
              isSelected={isSelected}
              variant="title-small"
              align="center"
            >
              {title}
            </OptionItemSquareWithIconTitleStyles>
          </OptionItemSquareWithIconStyles>
        )}
      </AnimatePresence>
    );
  }

  const scale = isSelected ? 1.03 : 1;

  return (
    <OptionItemSquareWithIconStyles
      isSelected={isSelected}
      onClick={onClick}
      data-testid={TEST_ID}
      initial={{
        scale,
      }}
      animate={{
        scale,
      }}
    >
      {Icon && <Icon />}
      <OptionItemSquareWithIconTitleStyles
        isSelected={isSelected}
        variant="title-small"
        align="center"
      >
        {title}
      </OptionItemSquareWithIconTitleStyles>
    </OptionItemSquareWithIconStyles>
  );
};
